import React from 'react';
import { useIntl } from 'react-intl';
import { Heading } from '../../../typography';
import { calendarDate } from '../../../../utils/dateUtility';
import { getGroupActivityDate, getGroupPreview } from '../../../../utils/internalChatGroups';
import Avatar from '../../../avatar/Avatar';
import GroupAvatar from '../groupAvatar/GroupAvatar';
import UserStatus from "../../../userStatus/UserStatus";
import { useSelector } from 'react-redux';
import './contact-details.scss';

/** O mesmo cartão serve à conversa individual (`user`) e ao grupo (`group`). */
export const ContactDetails = ({ user, group, position }) => {

    const intl = useIntl();
    const contacts = useSelector(state => state.internalChat.contacts);
    const userStatus = useSelector(state => state.internalChat.userStatus.byUserId)[user?.userId] || null;

    const getUserData = React.useMemo(() => {
        if(user?.userId){
            return contacts.find(contact => contact.userId === user.userId) || false;
        } else {
            return null
        }
    }, [contacts, user?.userId]);

    const details = React.useMemo(() => {
        if (!group) {
            return {
                name: user?.name,
                date: user?.dateLastMessage,
                lastMessage: user?.lastMessage
            };
        }

        const preview = getGroupPreview(group);
        return {
            name: group.name,
            date: getGroupActivityDate(group),
            lastMessage: preview?.participantsCount !== undefined
                ? intl.formatMessage({ id: "{count} participante(s)" }, { count: preview.participantsCount })
                : preview?.text
        };
    }, [user, group, intl]);


    return (<div
        style={{ top: position.y - 5 }}
        className={`contact-details-ui ${(user || group) && (position.y > 0 || position.x > 0) ? "show" : ""}`}>
        {group ?
            <GroupAvatar group={group} size="lg" /> :
            <Avatar
                name={user?.name}
                size="lg"
                style={{ backgroundColor: user?.color?.light, color: user?.color?.dark }}
                status={userStatus ? <UserStatus.Marker status={userStatus} /> : null} />
        }
        <div className="contact-details-info">
            <div className="contact-details-info-header">
                <Heading type="h6" fw={600} color="primary">{details.name}</Heading>{details.date && <span>{calendarDate(details.date)}</span>}
            </div>
            <div className="contact-details-info-last-message">
                {details.lastMessage}
            </div>
        </div>
    </div>)
};

export default React.memo(ContactDetails);
